module.exports = __webpack_public_path__ + "static/media/BrownTS_Biography.76952755.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/aboutme/BrownTS_Biography.pdf
// module id = 346
// module chunks = 0